
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Link } from 'office-ui-fabric-react/lib/Link';

import Text from '../../common/client/components/Text';

import { getDrupozTitle } from '../../reducers/drupoz';
import { getOpsubAddress, getOpsubName } from '../../reducers/opsub';
import { getParName } from '../../reducers/par';

import IfComp from '../common/IfComp';

const classNames = mergeStyleSets({
    telContainer: {
        paddingBottom: 8,
        marginBottom: 8,
        borderBottom: '1px solid #cccccc'
    },
    opsub: {
        paddingLeft: 32
    },
    opsubContainer: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 16
    },
    par: {
        paddingLeft: 32
    },
    parName: {
        width: 100
    },
    parType: {
        width: 40
    },
    parDrupoz: {
        paddingLeft: 32,
        width: 200
    },
    parVymera: {
        width: 100,
        textAlign: 'right'
    },
    parContainer: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 16
    }
});

const AnalyzeOpsub = ({opsubItem, vla}) => {
    return (
        <Stack horizontal className={classNames.opsub}>
            <Text bold>{getOpsubName(opsubItem)}</Text>
            <Text>, {getOpsubAddress(opsubItem)}</Text>
            <Text>, ({`${vla.podil_citatel}/${vla.podil_jmenovatel}`})</Text>
            <IfComp cond={vla.typrav_kod !== '30'}>
                <Text bold> * </Text>
            </IfComp>
        </Stack>
    )
}

const AnalyzeOpsubTel = ({analyzeResult, tel}) => {
    const vlaItems = analyzeResult.vla
        .filter(item => (item.tel_id === tel.tel_id));

    return (
        <Stack className={classNames.opsubContainer}>
            <Text>Vlastníci:</Text>
            {vlaItems.map(item => {
                let opsubItem = analyzeResult.opsub.reduce((previous, current) => {
                    return (current.opsub_id === item.opsub_id)
                        ? current
                        : previous;
                }, null);
                return (
                    <AnalyzeOpsub
                        key={opsubItem.opsub_id}
                        opsubItem={opsubItem}
                        vla={item}
                    />
                );
            })}
        </Stack>
    );
}

const AnalyzePar = ({parItem, onShowInMap}) => {

    const drupozTitle = useSelector(state => getDrupozTitle(state.drupoz, parItem.drupoz_kod));

    const handleClickMap = () => {
        if (onShowInMap) {
            onShowInMap(parItem);
        }
    }

    return (
        <Stack horizontal verticalAlign="end" className={classNames.par}>
            <Text bold className={classNames.parName}>{getParName(parItem)}</Text>
            <Text className={classNames.parType}>{parItem.par_type}</Text>
            <Text className={classNames.parVymera}>{parItem.vymera_parcely} m<sup>2</sup></Text>
            <Text className={classNames.parDrupoz}>{drupozTitle}</Text>
            <IfComp cond={!!onShowInMap && !!parItem.souradnice_x && !!parItem.souradnice_y}>
                <Link onClick={handleClickMap} >Do mapy</Link>
            </IfComp>
        </Stack>
    )
}

const AnalyzeParTel = ({analyzeResult, tel, onShowInMap}) => {
    const parItems = analyzeResult.par.filter(
        item => item.tel_id === tel.tel_id
    );

    return (
        <Stack className={classNames.parContainer}>
            <Text>Parcely:</Text>
            {parItems.map(item => {
                return (
                    <AnalyzePar
                        key={item.par_id}
                        parItem={item}
                        onShowInMap={onShowInMap}
                    />
                );
            })}
        </Stack>
    );
}

const TelesoInfo = ({data, tel, onShowInMap}) => {

    const vymera = data.par
        .filter(item => item.tel_id === tel.tel_id)
        .reduce((previous, current) => {
            return previous + parseInt(current.vymera_parcely);
        }, 0);

    return (
        <Stack className={classNames.telContainer}>
            <Stack horizontal tokens={{childrenGap: 8}} verticalAlign="end">
                <Text>KÚ:</Text>
                <Text bold>{tel.katuze_nazev}</Text>
                <Text>({tel.katuze_kod})</Text>
                <Text>- Číslo LV:</Text>
                <Text bold>{tel.cislo_tel}</Text>
                <Text>- Výměra LV:</Text>
                <Text>{vymera} m<sup>2</sup></Text>
            </Stack>
            <AnalyzeOpsubTel
                analyzeResult={data}
                tel={tel}
            />
            <AnalyzeParTel
                analyzeResult={data}
                tel={tel}
                onShowInMap={onShowInMap}
            />
        </Stack>
    );
}

export default TelesoInfo;
